import { FILTER_CHANGE } from '../../constants'

const guestsChange = (field, value, dispatch, state) => {
  const { form: { searchFilters: { rooms } } } = state
  const [guest, id] = field.split('_')
  const key = rooms.findIndex(room => room.id === id)
  const room = {
    ...rooms[key],
    ...{ [guest]: value },
  }
  rooms.splice(key, 1, room)

  dispatch({ type: FILTER_CHANGE, filterType: 'rooms', values: [...rooms] })
}

export default (
  field, value,
) => (dispatch, getState) => guestsChange(field, value, dispatch, getState())
